import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Sparkles } from 'lucide-react';
import api, { setToken } from '../lib/api';
import { toast } from '../hooks/use-toast';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      // Emergent returns the session_id in URL fragment: #session_id=xxx
      const hash = window.location.hash || '';
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;

      if (!sessionId) {
        toast({ title: 'Sign-in failed', description: 'No session returned from Google.' });
        navigate('/login', { replace: true });
        return;
      }

      try {
        const { data } = await api.post('/auth/emergent-session', { session_id: sessionId });
        setToken(data.token);
        toast({ title: `Welcome${data.user?.name ? ', ' + data.user.name.split(' ')[0] : ''}!` });
        // Clean the URL fragment and go to dashboard
        window.history.replaceState({}, '', '/dashboard');
        window.location.href = '/dashboard';
      } catch (err) {
        toast({
          title: 'Sign-in failed',
          description: err?.response?.data?.detail || 'Could not complete Google sign-in.',
        });
        navigate('/login', { replace: true });
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#fdfaf6] flex items-center justify-center px-5">
      <div className="text-center">
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-400 to-rose-500 flex items-center justify-center mx-auto shadow-md">
          <Sparkles className="w-6 h-6 text-white" strokeWidth={2.5} />
        </div>
        <Loader2 className="w-6 h-6 mx-auto mt-6 text-orange-500 animate-spin" />
        <div className="mt-3 text-slate-600">Signing you in…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
